import { useAppDispatch, useAppSelector } from 'hooks';
import React, { useEffect } from 'react';
import { patientsActions } from 'utils/store';
import { ConnectNewPatient, ConnectedPatients } from './components';

export const ConnectPatientScreen = () => {
  const dispatch = useAppDispatch();
  const caregiverId = useAppSelector((state) => state.user?.data?.caregiverId);

  useEffect(() => {
    if (caregiverId) {
      dispatch(patientsActions.getCaregiverPatientsData({ id: caregiverId }));
    }
  }, [caregiverId, dispatch]);

  return (
    <>
      <ConnectNewPatient />
      <ConnectedPatients />
    </>
  );
};
